var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWeightBodyConditionScore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "bcs") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_45",
    "data-name": "Layer 45"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.02,
    width: 600,
    height: 600,
    fill: "none",
    opacity: 0
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_58",
    "data-name": "Layer 58"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 300,
    cy: 384.04,
    rx: 300,
    ry: 60.77,
    fill: "#00a388"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.77,92.78a144.18,144.18,0,0,1,45.88,68.28,155.31,155.31,0,0,1,3.73,81.61,141.67,141.67,0,0,1-38.94,71L324.54,527C317.43,534.1,300,537.66,300,537.66S282.57,534.1,275.46,527L69.56,314.68q-29.87-30.93-38.94-72a155.31,155.31,0,0,1,3.73-81.61A144.18,144.18,0,0,1,80.23,92.78a135,135,0,0,1,65.08-30.94,143.71,143.71,0,0,1,71.48,5.33,151.18,151.18,0,0,1,61.87,39.48L300,128l21.34-21.33a151.18,151.18,0,0,1,61.87-39.48,143.71,143.71,0,0,1,71.48-5.33A135,135,0,0,1,519.77,92.78Z",
    fill: "#7effaa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300,323.26c165.69,0,300,27.22,300,60.77V257.9h0c0-33.56-134.31-60.77-300-60.77S0,224.34,0,257.9H0V384C0,350.48,134.31,323.26,300,323.26Z",
    fill: "#00d89a"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "409.38 272.88 268.45 152.09 268.45 393.66 409.38 272.88",
    fill: "#7effaa"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "353.61 272.88 212.68 152.09 212.68 393.66 353.61 272.88",
    fill: "#00d89a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeightBodyConditionScore);
export default __webpack_public_path__ + "static/media/weight_body_condition_score.3c877dab0716ceaae0feda553870d029.svg";
export { ForwardRef as ReactComponent };